/* eslint-disable prettier/prettier */
import css from 'styled-jsx/css';

export default css`
  .modal__header {
    background-color: #ffffff;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
  }
  .img-fluid {
    width: 10rem;
    height: auto;
  }
  :global(.modal__close) {
    padding: 0.625rem;
    cursor: pointer;
  }
  .modal__content {
    overflow-y: auto;
    padding: 2rem;
    text-align: justify;
  }
  .modalCliente {
    width: 100vw;
    max-width: 35rem;
    background-color: var(--color-gp--white);
    padding: 30px;
  }
  .modalTit {
    font: normal normal bold 18px Bold;
    text-align: left;
    color: var(--color-gp--blue-dark);
  }
  .options {
    margin-top: 15px;
  }
  .modalOpcion {
    position: relative;
    display: block;
    margin-bottom: 10px;
    text-align: left;
    padding: 22px 30px;
    background-color: var(--color-gp--grey1);
  }
  .modalOpcion:hover {
    background-color: var(--color-gp--grey1a);
  }
  @media screen and (max-width: 768px) {
    .img-fluid {
      width: 7rem;
      height: auto;
    }
  }
`;
